import { Route } from 'react-router-dom';
import { LandingPage } from '../pages/LandingPage/index';
import { MentorCalendarConnect } from "../pages/MentorCalendarConnect";
import { MentorAvailability } from "../pages/MentorAvailability";
import { MenteesList } from "../pages/MenteesList/index";
import { Appointments } from "../pages/Appointments/index";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { PreSession } from "../pages/PreSession/index";
import { Session } from "../pages/Session/index";
import { PostSession } from "../pages/PostSession/index";
const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID;

export const mentorRoutes = (
  <>
    <Route index element={<LandingPage />} />
    <Route path="mentees" element={<MenteesList />} />
    <Route path="appointments" element={<Appointments />} />
    <Route path="pre-session" element={<PreSession />} />
    <Route path="session" element={<Session />} />
    <Route path="post-session" element={<PostSession />} />
    <Route
      path="calendar/connect"
      element={
        <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
          <MentorCalendarConnect />
        </GoogleOAuthProvider>
      }
    />
    <Route
      path="calendar/availability"
      element={
        <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
          <MentorAvailability />
        </GoogleOAuthProvider>
      }
    />
  </>
);